import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MethodsService} from './services/methods.service';
import {HttpClientModule} from '@angular/common/http';
import {HeaderComponent} from './shared/headers/header/header.component';
import {CommonsService} from './services/commons.service';
import {SWIPER_CONFIG, SwiperConfigInterface, SwiperModule} from 'ngx-swiper-wrapper';



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    SwiperModule
  ],
  providers: [MethodsService, CommonsService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
